<template>
  <div class="Contact" style="position:fixed;">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Contact</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col col cols="12" sm="3" md="3" lg="3" class="sideNav" style="height:72vh; width:60vw;">
              <ContactSideNav/>
          </b-col>
          <b-col col cols="12" sm="12" md="12" lg="3" class="dropdownmenu">
              <ContactMobileDropDown/>
          </br>
          </b-col>
         <b-col col cols="12" sm="12" md="12" lg="9" style="width:90vw;">
            <ContactContent />
          </b-col>
        </b-row>
      </b-container>
      <br><br><br><br>
  </div>
</template>

<script>
import ContactSideNav from '@/components/ContactSideNav.vue'
import ContactMobileDropDown from '@/components/ContactMobileDropDown.vue'
import ContactContent from '@/components/ContactContent.vue'
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'

export default {
  name: 'Contact',
  components: {
    'ContactSideNav' : ContactSideNav,
    'ContactMobileDropDown' : ContactMobileDropDown,
    'ContactContent' : ContactContent,
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    }
}


</script>

<style scoped="true">
    li{
      padding:0;
    }

    body{
      overflow-y:hidden;
    }
    .headerF{
      display: block;
    }
    .headerM{
      display: none;
    }
    .sideNav{
      height:75vh;
      overflow-y:hidden;
    }
    .dropdownmenu{
      display: none;
    }
    @media (max-width: 768px) {
        .headerF{
          display: none;
        }
        .headerM{
          display: block;
        }
        .sideNav{
          /* height:50vh;
          overflow-y:hidden; */
          display: none
        }
        .dropdownmenu{
          display: block;
        }
      }
      @media (max-width: 576px) {
        .sideNav{
          /* height:50vh;
          overflow-y:hidden; */
          display: none
        }
        .dropdownmenu{
          display: block;
        }
      }
</style>
